import styled from 'styled-components';
export const DialogContainer = styled.div.attrs({
  id: 'DialogContainer',
})`
  padding: 25px;
`;
